<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<v-row class="iframe-field-settings field-settings" no-gutters>
				<v-col cols="12" class="text-left py-3">
					<div class="settings-title">URL:</div>
					<CombinedInputFieldDataMenu :value.sync="url" :textAreaMode="false" :valuesTypes="dataInputMenuValueTypes" />
					<div class="field-setting-section">
						<div class="settings-title">Query Params:</div>
						<perfect-scrollbar class="query-param-options-section">
							<Container @drop="onDrop">
								<Draggable v-for="opt in queryParamOptions" :key="opt.id">
									<KeyValueOption
										class="option-container mr-3"
										:ref="`keyValueOption-${opt.id}`"
										:data="opt"
										@updateOption="updateOption"
										@onEnterKey="addOption"
										@removeOption="removeOption"
										:can-remove="true"
										:attachToValue="'.iframe-field-settings'"
									/>
								</Draggable>
							</Container>
						</perfect-scrollbar>

						<div class="add-option inline-link-style highlighted" @click="addOption">[+] Add Option</div>
					</div>
					<br />
					<!-- <div class="notice">To prevent submitting the interface until iframe changes url - go to "Interface settings"</div> -->
					<WidgetSettingsItem :item="iframeRedirectSetting" />
				</v-col>
			</v-row>
		</ExpansionPanel>
	</v-expansion-panels>
</template>

<script>
import { applyDrag } from '@/utils/helpers';
import { Draggable, Container } from 'vue-smooth-dnd';
import KeyValueOption from './FieldOptions/KeyValueOption';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
import WidgetSettingsItem from '@/components/BlockEditorWidget/FieldSettings/WidgetSettings/WidgetSettingsItem';
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
const getOption = (options, optionObj) => {
	const maxId = options.length === 0 ? 0 : Math.max(...options.map((o) => o.id));
	return { id: maxId + 1, ...optionObj };
};

export default {
	name: 'IframeFieldSettings',
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	components: {
		Draggable,
		Container,
		KeyValueOption,
		WidgetSettingsItem,
		CombinedInputFieldDataMenu,
	},
	computed: {
		iframeRedirectSetting() {
			return {
				key: 'iframeSubmitDisabled',
				label: 'Required (URL based)',
				canEnable: true,
				default: 0,
				description: 'Prevent submitting the interface until the iframe redirects to a different URL',
			};
		},
		queryParamOptions: {
			get() {
				return this.localField.metadata.options.previous_steps.query_params || [];
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.previous_steps.query_params', value);
			},
		},
		url: {
			get() {
				if (this.localField.metadata.options.previous_steps.url) {
					return this.localField.metadata.options.previous_steps.url.value;
				}
				return '';
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.previous_steps.url.value', value);
			},
		},
	},
	methods: {
		onDrop(dropResult) {
			this.queryParamOptions = applyDrag(this.queryParamOptions, dropResult);
		},
		addOption() {
			const newOption = getOption(this.queryParamOptions, { text: '', value: '' });
			this.queryParamOptions.push(newOption);
			this.$nextTick(() => {
				this.$refs[`keyValueOption-${newOption.id}`][0].focusInput();
			});
		},
		updateOption(optionData) {
			const optIndex = this.queryParamOptions.findIndex((o) => o.id === optionData.id);
			const options = [...this.queryParamOptions];
			Object.assign(options[optIndex], optionData);
			this.queryParamOptions = options;
		},
		removeOption(opt) {
			this.queryParamOptions = this.queryParamOptions.filter((o) => o.id !== opt.id);
		},
	},
};
</script>

<style scoped lang="scss">
.iframe-field-settings {
	.option-container {
		margin: 3px 0 3px 0;
	}
	.add-option {
		margin: 3px 0 0 0;
		font-size: 14px;
	}
	.field-setting-section {
		.query-param-options-section {
			max-height: 478px;
		}
	}

	.v-select-container:not(.is-selectable) {
		pointer-events: none;
		opacity: 0.6;
		transition: 0.3;
	}
}
.notice {
	font-size: 12px;
	width: 90%;
}
</style>
